import { api } from "~/utils/api"

export const useProductDetails = () => {
  const query = api.productDetails.getAll.useQuery()

  return {
    colors: { data: query.data?.colors, isLoading: query.isLoading },
    categories: { data: query.data?.categories, isLoading: query.isLoading },
    brands: { data: query.data?.brands, isLoading: query.isLoading },
    vendors: { data: query.data?.vendors, isLoading: query.isLoading },
    genders: { data: query.data?.genders, isLoading: query.isLoading },
    sizes: { data: query.data?.sizes, isLoading: query.isLoading },
  }
}
